// @ts-ignore
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { LocalFind, LocalInsert } from '@weblite/persist'
import { sendFcmTokenToServer } from '$logic/push/service'
import { envMode, envModes } from '$config/env'

const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG || null)
// @ts-ignore
const VAPID_KEY = import.meta.env.VITE_VAPID_KEY

let firebaseSWRegistration: ServiceWorkerRegistration | undefined

export async function initializeFirebaseMessaging() {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications.')
    return
  }

  initializeApp(firebaseConfig)
  const messaging = getMessaging()

  firebaseSWRegistration = await registerFirebaseServiceWorker()

  if (!firebaseSWRegistration) {
    console.error("couldn't register firebase service worker")
    return
  }

  const token = await getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: firebaseSWRegistration,
  })

  const oldToken = LocalFind('fcmRegistrationId')
  if (token !== oldToken) {
    LocalInsert('fcmRegistrationId', token)
    sendFcmTokenToServer(token)
  }
}

export const removeFCMServiceworkerRegistration = () => {
  navigator.serviceWorker?.getRegistrations().then(function (registrations) {
    registrations.forEach(registration => {
      const scopeUrl = new URL(registration.scope)
      if (scopeUrl.pathname === '/firebase-cloud-messaging-push-scope') {
        void registration.unregister()
      }
    })
  })
}

export function postMessageToFirebaseSWR(message: any) {
  if (firebaseSWRegistration?.active)
    firebaseSWRegistration.active.postMessage(message)
}

export async function registerFirebaseServiceWorker() {
  if ('serviceWorker' in navigator && envMode === envModes.PRODUCTION) {
    return navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/firebase-cloud-messaging-push-scope',
    })
  }
  return undefined
}
